/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-10-15 13:44:49
 *
 *******************************************************/
// @flow

import { getJSON } from 'redux-api-middleware';
import { I18n } from '@shopify/react-i18n';

import apiService from 'src/services/api-service';
import {
  INTEGRATION_FAILURE,
  INTEGRATION_REQUEST,
  INTEGRATION_SUCCESS
} from 'stores/flow-type/integration.type';
import { APPS_BANNERS } from 'src/constants/integration';

/**
 * call to get font list api
 * @return {object} The RSAA object for API middleware
 */
export const getIntegrationBanners = (i18n: I18n) => {
  return apiService.sendRequest('admin-v3.integration.get-integration-banners', {}, [
    INTEGRATION_REQUEST,
    {
      type: INTEGRATION_SUCCESS,
      payload: async (action, state, res) => {
        const { data } = await getJSON(res);

        return { data };
      }
    },
    {
      type: INTEGRATION_FAILURE,
      payload: async (action, state, res) => {
        return { data: APPS_BANNERS };
      }
    }
  ]);
};
